// ANGULAR DEPENDENCY
import { NgModule } from '@angular/core';

// NGRX
import { EffectsModule } from '@ngrx/effects';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

// STORE REDUCER AND EFFECTS
import { RequestEffects } from './store/effects';
import * as fromRequest from './store/reducer';

// SERVICES
import { RequestStoreService } from './request-store.service';
import { RequestService } from './services/request.service';


/**
 * Local storage sync function for sync store state keys with local storage
 */
export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['request'], rehydrate: true })(reducer);
}

// add localstorage function in meta reducers
const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];

/**
 * This module is for configure Request ngrx related stuff.
 *
 *   @author Nirmal Jodhani <nirmal.jodhani@saeculumsolutions.com>
 * Notes:-
 * Date: 17/06/2020 Request store module created
 */
@NgModule({
  imports: [
    StoreModule.forFeature('Task', fromRequest.reducer, { metaReducers }),
    EffectsModule.forFeature([RequestEffects]),
  ],
  declarations: [],
  providers: [
    RequestService,
    RequestStoreService,
  ],
})
export class RequestStoreModule { }
